import React from 'react'
import inoveLogo from '../images/inove-02.png'
import ufcLogo from '../images/ufc-logo-white-min.png'


import $ from 'jquery'
import 'popper.js'
import 'bootstrap'

export default class NavBar extends React.Component {

    componentDidMount = () => {

        const isTransparent = this.props.transparent
        const bgColor = this.props.bgColor
        const isAnimated = this.props.animate


        if (!isTransparent || window.innerWidth <= 600)
            $('.navbar').css('background', bgColor)

        //Animação do menu
        if (isAnimated === true) {
            $(window).scroll(function () {
                var scroll = $(window).scrollTop()
                if (scroll > $('.navbar').height() || window.innerWidth <= 600) {
                    $('.navbar').css('background', bgColor)
                    $('.navbar').removeClass('p-3')
                    $('.navbar').addClass('p-0')
                    $('.navbar').addClass('shadow-lg')
                }
                else {
                    $('.navbar').removeClass('p-0')
                    $('.navbar').addClass('p-3')
                    $('.navbar').removeClass('shadow-lg')

                    if (isTransparent) {
                        $('.navbar').css('background', 'transparent')
                    }
                }
            })
        } else {
            $('.navbar').removeClass('p-3')
            $('.navbar').addClass('p-0')
            $('.navbar').addClass('m-0')
        }

        //animação de rolagem suave
        $('.navbar a[href^="#"]').on('click', function (event) {
            $('.navbar-collapse').collapse('hide'); //fecha o menu quando estiver no celular

            var target = $(this.getAttribute('href'));
            if (target.length) {
                event.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: target.offset().top
                }, 500);
            }
        });
    }

    render() {
        const navLinks = this.props.navLinks

        return (
            <nav className="navbar navbar-expand-lg  navbar-dark fixed-top p-3" style={{ backgroundColor: 'transparent' }}>

                <div className="w-75 mx-auto row">
                    <a className="navbar-brand" href="/">
                        <img src={inoveLogo} className="mt-2" alt="logo do INOVE" width="120" height="80" />
                        <div className="d-inline-block bg-white align-bottom mx-3" style={{ height: '80px', width: '2px' }}></div>
                        <img src={ufcLogo} alt="logo da unversidade federal do ceará" height="80" />
                    </a>

                    <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">

                        <ul style={{ fontSize: "20px" }} className="navbar-nav ml-auto font-weight-bold">

                            {!$.isEmptyObject(navLinks)
                                ? Object.keys(navLinks).map((key, index) => (
                                    <li key={index} className="nav-item">
                                        <a className="nav-link text-white" href={navLinks[key]}>
                                            <p>{key}</p>
                                        </a>
                                    </li>
                                ))
                                : <></>
                            }
                        </ul>
                    </div>
                </div>
            </nav >
        );
    }
}